import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { IProduct, IProductEdp } from './IProduct';
import classnames from 'classnames';

export interface PdpProps {
    SelectedEdpItem: IProductEdp;
    ProductData: IProduct;
    isAutoDeliveryEnabled: boolean;
    showSticky: boolean;
    children: any;
    entry: any;
}
const PdpSticky = ({ SelectedEdpItem, ProductData, isAutoDeliveryEnabled, showSticky, children, entry }: PdpProps) => {
    const {
        Name,
        ItemNo,
        DefaultEdp,
        IsSoldOut,
        DeliveryOptions,
        IsPriceRange,
        WasPriceRange,
        ProductReviewCount,
        ProductReviewRating,
        Styles = [],
        Sizes = [],
        AvailableSwatches,
        Edps,
        Brand,
        BrandDimensionId,
        BadgeImagePath,
        ProductTypePath,
    } = ProductData;

    const productName = useMemo(() => {
        if (isAutoDeliveryEnabled) {
            return DeliveryOptions.find((item) => item.EdpNo == SelectedEdpItem.EdpNo).DisplayName;
        } else {
            return Name;
        }
    }, [DeliveryOptions, SelectedEdpItem, Name, isAutoDeliveryEnabled]);

    return (
        <div
            className={classnames('pdp-sticky', {
                'pdp-sticky__visible': !showSticky && entry?.boundingClientRect.top < 0,
            })}
        >
            {children}
        </div>
    );
};

export default PdpSticky;
